var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C9.735 3 3 9.735 3 18C3 26.265 9.735 33 18 33C26.265 33 33 26.265 33 18C33 9.735 26.265 3 18 3ZM23.04 21.45C23.475 21.885 23.475 22.605 23.04 23.04C22.815 23.265 22.53 23.37 22.245 23.37C21.96 23.37 21.675 23.265 21.45 23.04L18 19.59L14.55 23.04C14.325 23.265 14.04 23.37 13.755 23.37C13.47 23.37 13.185 23.265 12.96 23.04C12.525 22.605 12.525 21.885 12.96 21.45L16.41 18L12.96 14.55C12.525 14.115 12.525 13.395 12.96 12.96C13.395 12.525 14.115 12.525 14.55 12.96L18 16.41L21.45 12.96C21.885 12.525 22.605 12.525 23.04 12.96C23.475 13.395 23.475 14.115 23.04 14.55L19.59 18L23.04 21.45Z",
    fill: "#f5f6f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelLike);
export default __webpack_public_path__ + "static/media/cancelLike.8f1a098748dd8ad7a44364818bef9f2d.svg";
export { ForwardRef as ReactComponent };